import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { REQUEST_PASSWORD_RESET_LINK_MUTATION } from "graphql/APICalls";

import 'styles/ForgotPasswordPage.css';

export default function ForgotPasswordPage() {
  const [emailOrUsername, setEmailOrUsername] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [requestResetLink, { loading }] = useMutation(REQUEST_PASSWORD_RESET_LINK_MUTATION);

  async function handleSubmit(e) {
    e.preventDefault();
    setErrorMessage('');
    setMessage('');
    requestResetLink({
      variables: { emailOrUsername },
      onCompleted: () => {
        setMessage("If an account with that email or username exists, a password reset link has been sent.");
      },
      onError: (error) => {
        setErrorMessage(error.message);
      }
    });
  }

  return (
    <div className="auto-scrollbar">
      <div className="centerer login-signup-overlay">
        {message ? (
          <div className="centered message">
            <img src={"/envelope.svg"} alt="envelope"/>
            <p>{message}</p>
          </div>
        ) : (
          <form className="centered form-1" onSubmit={handleSubmit}>
            <p className="wide">Enter your email or username and we'll send you a link to reset your password.</p>
            <label>Email or username</label>
            <input 
              type="text" 
              value={emailOrUsername} 
              onChange={(e) => setEmailOrUsername(e.target.value.trim())} 
              required 
            />
            <div className="wide error-message" style={{display: errorMessage.length ? 'block' : 'none'}}>{errorMessage}</div>
            <button type="submit" disabled={loading}>Send reset link</button>
          </form>
        )}
      </div>
    </div>
  );
}
